// extracted by mini-css-extract-plugin
module.exports = {"releaseImg":"press-release_releaseImg__3ZVOo","releaseItem":"press-release_releaseItem__74FW1","releaseWrap":"press-release_releaseWrap__3oWa9"};